var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AnalyticServiceVendor from './enums/analytics-service-vendor-type';
import { GTMService } from './services';
import ThemisAnalyticsOptionsValidator from './services/validators/themis-analytics-options.validator';
export default class ThemisAnalytics {
    constructor(options) {
        this.defaultOptions = options;
        this.gtmService = new GTMService(options);
        this.analyticsOptionsValidator = new ThemisAnalyticsOptionsValidator();
    }
    initialize(analyticsOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = Object.assign({}, this.defaultOptions, analyticsOptions);
            let initialized = false;
            this.analyticsOptionsValidator.validate(options);
            // The SWITCHes on client is an architectural reminder
            // This is patterned to support many different analytics clients
            // mostly this is here to support a move to GA4 if needed
            switch (options.client) {
                case AnalyticServiceVendor.GoogleTagManager:
                    initialized = yield this.gtmService.initialize(options);
                    break;
            }
            return initialized;
        });
    }
    triggerEvent(eventName) {
        var _a;
        switch ((_a = this.defaultOptions) === null || _a === void 0 ? void 0 : _a.client) {
            case AnalyticServiceVendor.GoogleTagManager:
                this.gtmService.triggerEvent(eventName);
                break;
        }
    }
    triggerCustomEvent(eventName, variables) {
        var _a;
        switch ((_a = this.defaultOptions) === null || _a === void 0 ? void 0 : _a.client) {
            case AnalyticServiceVendor.GoogleTagManager:
                this.gtmService.triggerCustomEvent(eventName, variables);
                break;
        }
    }
}
//# sourceMappingURL=themis-analytics.js.map